import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import getToken from '../../addTokenInterceptor'
import breadCrumbIcon from '../../assets/breadcrumb-icon.png'
import { runtimeConfig } from '../../runtimeConfig'
import './index.scss'

interface IBreadcrumb {
  currentScreen: string
  setCurrentScreen: (value: string) => void
}
const BreadCrumb: React.FC<IBreadcrumb> = (props: IBreadcrumb) => {
  const location = useLocation()
  const { projectId } = getToken()
  const navigate = useNavigate()

  const handleNavigate = () => {
    const outputCategory = `${
      runtimeConfig.VITE_ASCEND_1_1_URL
    }/v2/output-category?ascend_project_id=${projectId}`
    window.open(outputCategory, '_self')
  }

  return (
    <div className='breadcrumb-container'>
      <div className='breadcrumb-non-active-head' onClick={handleNavigate}>
        Output Category
      </div>
      <div className='divider'>
        <img src={breadCrumbIcon} alt='breadcrumb' />{' '}
      </div>
      <div className='breadcrumb-non-active-head'>Workshop Assistant </div>
      <div className='divider'>
        <img src={breadCrumbIcon} alt='breadcrumb' />{' '}
      </div>
      <div
        className={
          props?.currentScreen === 'WorkshopDetails'
            ? 'breadcrumb-active-head'
            : 'breadcrumb-non-active-head'
        }
        onClick={() => {
          props?.setCurrentScreen('WorkshopDetails')
        }}
      >
        Workshop Details
      </div>
      {props?.currentScreen === 'fileUpload' && (
        <>
          <div className='divider'>
            <img src={breadCrumbIcon} alt='breadcrumb' />{' '}
          </div>
          <div
            className={
              props?.currentScreen === 'fileUpload'
                ? 'breadcrumb-active-head'
                : 'breadcrumb-non-active-head'
            }
          >
            Files Upload & Output Generation
          </div>
        </>
      )}
    </div>
  )
}

export default BreadCrumb
